import {Component, Input} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {Store} from "../../../services/store.service";
import {TranslatedBaseError} from "../../pages/TranslatedBaseError";

@Component({
  selector: "business-key",
  templateUrl: "./business-key.component.html",
})
export class BusinessKeyComponent extends TranslatedBaseError {

  @Input() public businessKey: string = "";
  @Input() public extraClass: string = "";
  @Input() public businessKeyTooltip: string = "businessKey";
  @Input() public tooltipPosition: string = "bottom";
  @Input() public fullButton: boolean = false;

  constructor(toastr: ToastrService,
              translateService: TranslateService,
              private store: Store) {
    super(toastr, translateService);
  }

  public get shouldDisplay(): boolean {
    return this.store?.state?.common?.userLevels?.pages?.SideNavLevel === 3;
  }

  public copyToClipboard(key: string): void {
    navigator.clipboard.writeText(key).then(() => {
      this.responseSuccessful("Business key copied to clipboard");
    }).catch((err) => {
      console.error("Could not copy text: ", err);
    });
  };
}
